var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSourceBigOutlineIcon = function SvgSourceBigOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M40.5 12.75C40.5 17.306 33.113 21 24 21S7.5 17.306 7.5 12.75m33 0c0-4.556-7.387-8.25-16.5-8.25S7.5 8.194 7.5 12.75m33 0v22.5c0 4.556-7.387 8.25-16.5 8.25S7.5 39.806 7.5 35.25v-22.5m33 0v7.5m-33-7.5v7.5m33 0v7.5C40.5 32.306 33.113 36 24 36S7.5 32.306 7.5 27.75v-7.5m33 0c0 4.556-7.387 8.25-16.5 8.25S7.5 24.806 7.5 20.25"
  })));
};
export { SvgSourceBigOutlineIcon as ReactComponent };
export default __webpack_public_path__ + "155e44c89d012dd99e86276c037ce457.svg";